export default "__VITE_ASSET__D38Rrs9o__"